import { getDependentPaths } from "../utils/storeUtils";
import { createJSONData } from "../utils/dataUtils";
import internalStateService from "../app/InternalStateService";
import translationService from "../app/TranslationService";
import {
    CANCEL_FLOW_REQUEST,
    CANCEL_FLOW_SUCCESS,
    COMPLETE_FLOW_REQUEST,
    COMPLETE_FLOW_SUCCESS,
    STEP_POST_REQUEST
} from "./Flow";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export function processStep(sirenAction, widgetId, path) {
    return (dispatch, getState) => {
        let source = sirenAction.sources ? sirenAction.sources : [widgetId];
        let stepData = constructRequestEntity(source, getState(), path, sirenAction, widgetId);

        return dispatch(processToStep(sirenAction, stepData, widgetId));
    };
}

function processToStep(sirenAction, stepData, widgetId) {
    return async dispatch => {
        let result = await dispatch(
            requestSubmitStep(sirenAction.href, "POST", widgetId, stepData)
        );
        // dispatch(
        //     internalStateService.getActionByName("flow.realodFlowOnProcessStep")(widgetId, stepData)
        // );
        return result;
    };
}

function requestSubmitStep(endpoint, method, widgetId, payload) {
    WEBUILogs.log("requestSubmitStep");
    return async (dispatch, getState) => {
        let actionResult;
        try {
            await dispatch({
                type: STEP_POST_REQUEST
            });
            dispatch(internalStateService.getActionByName("loading.triggerGlobalLoading")());

            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: method,
                        headers: {
                            "Content-Type": `application/json`
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            if (!actionResult) {
                actionResult = { isEmpty: true };
            }
            // await dispatch({
            //     type: STEP_POST_SUCCESS,
            //     payload: Object.assign({}, payload, actionResult, {
            //         widgetId: widgetId,
            //         step: stepId
            //     })
            // });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("stepPostFailure")]
                        }
                    ])
                );
            }
        } finally {
            dispatch(internalStateService.getActionByName("loading.dismissGlobalLoading")());
        }
        return actionResult;
    };
}

function constructRequestEntity(sources, state, currentPath, sirenAction, currentWidgetId) {
    let requestEntity;
    let extractedEntities = sources.map(dependency => {
        let dependentStorePaths = getDependentPaths([dependency], state, currentPath);
        return {
            class: [dependency],
            entities: dependentStorePaths.map(dependentStorePath => {
                let result = state.getIn(["data", ...dependentStorePath]);
                return result ? result.toJS() : null;
            })
        };
    });

    requestEntity = extractedEntities[0].entities[0];

    let requestEntityPath;
    if (sources.length === 1) {
        requestEntityPath = sources[0] !== currentWidgetId ? sources[0] : "";
    }
    return createJSONData(requestEntity, sirenAction, requestEntityPath);
}

export function cancelFlow(sirenAction = {}, widgetId) {
    return async dispatch => {
        let payload = {
            action: {
                id: sirenAction.id,
                actionType: sirenAction.actionType,
                parameters: sirenAction.parameters
            },
            content: {}
        };

        let endpoint = sirenAction.href;

        let title = translationService.translate("dialogTitleAttention");
        let message = translationService.translate("flowCancelFlowMessage");
        //Modal type, "info" or "confirm" (having "OK" button only or "OK" and "Cancel")
        let type = "info";

        await dispatch(
            internalStateService.getActionByName("messages.openConfirmMessage")({
                title,
                messages: [message],
                type
            })
        );
        return dispatch(requestCancelFlow(endpoint, widgetId, payload));
    };
}

function requestCancelFlow(endpoint, widgetId, payload) {
    return async dispatch => {
        let actionResult;
        try {
            await dispatch({
                type: CANCEL_FLOW_REQUEST
            });
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: CANCEL_FLOW_SUCCESS,
                payload: Object.assign({}, payload, actionResult, { widget: widgetId })
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("cancelFlowFailure")]
                        }
                    ])
                );
            }
        }
        return actionResult;
    };
}

export function completeFlow(sirenAction, widgetId) {
    let payload = {
        action: {
            id: sirenAction.id,
            actionType: sirenAction.actionType,
            parameters: sirenAction.parameters
        },
        content: {}
    };
    return async dispatch => {
        let actionResult;
        try {
            await dispatch({
                type: COMPLETE_FLOW_REQUEST
            });
            await dispatch(
                internalStateService.getActionByName("flow.triggerResetActiveFlowTarget")()
            );

            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: sirenAction.href,
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: COMPLETE_FLOW_SUCCESS,
                payload: Object.assign({}, payload, actionResult, { widget: widgetId })
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("completeFlowFailure")]
                        }
                    ])
                );
            }
        }
        return actionResult;
    };
}
